import { render, staticRenderFns } from "./ProjectChartTemplate.vue?vue&type=template&id=c5457886&scoped=true&"
import script from "./ProjectChartTemplate.vue?vue&type=script&lang=ts&"
export * from "./ProjectChartTemplate.vue?vue&type=script&lang=ts&"
import style0 from "./ProjectChartTemplate.vue?vue&type=style&index=0&id=c5457886&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5457886",
  null
  
)

export default component.exports